(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/hero/topwins.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/hero/topwins.js');

'use strict';

const {
  useSelector
} = ReactRedux;
const Topwins = () => {
  const topWinTotal = useSelector(state => state.numbergames.jackpots.reduce((accumulator, object) => accumulator + object.jackpotAmount, 0));
  return React.createElement("div", {
    className: "gp-hero-topwins"
  }, React.createElement("p", {
    className: "h2"
  }, "Totala toppvinster"), React.createElement("p", null, "just nu"), React.createElement("p", {
    className: "h2"
  }, "ca ", topWinTotal / 1000000, " miljoner kr!"));
};
svs.gamePackage.components.Topwins = Topwins;

 })(window);